module.exports = __webpack_public_path__ + "img/US.9d5b694a.png";